import { ACTION_ADD_SITE_ALIASES } from '../actionTypes';


export const actionAddSiteAliases = siteAliases => ({
  type: ACTION_ADD_SITE_ALIASES,
  payload: { siteAliases },
});
